import { useEffect, useState } from "react";

const Competitions = ({ competitionElemProps }: { competitionElemProps: any }) => {
    const [competitionData, setcompetitionData] = useState([] as any);

    const onSetSettingsText = (e: any) => {
        let items = [...competitionData];

        let value = e.target.value;
        let data = e.target.dataset.name;
        let index = Number(e.target.dataset.index);
        
        // @ts-ignore
        let item = {...items[index]};
        // @ts-ignore
        item[data] = value;

        // @ts-ignore
        items[index] = item;

        setcompetitionData(items);
    }

    const onSelectEventElem = (elem: any) => {
        competitionElemProps.handleElemSelect(elem);
    }

    const deleteCompetition = (index_id: number, competitionName: string) => {
        let response = window.confirm(`Are you sure to delete this Event (${competitionName})?`);
        let object_data = [{
            "id": Number(index_id)
        }];

        if (response) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(object_data)
            };
            fetch('/api/competitions/delete', requestOptions)
                .then(response => response.json())
                .then(data => alert("Successfully saved your competitions."));

            competitionElemProps.handleUpdate();
        }
    }

    useEffect(() => {
        setcompetitionData(competitionElemProps.competitionData);
    }, [competitionElemProps.competitionData]);

    return (
        <div>
            <div className={(competitionData.length > 0) ? "data-event-grid mb-3" : ""} style={{ display: (competitionElemProps.show) ? "grid" : "none" }}>
                {(competitionData.length > 0) ? (competitionData.map((competition: any, index: number) => (
                    <div 
                        className={`data-event-grid__elem 
                            ${(competitionData[index]["status"] !== "disabled") ? 
                                (
                                    (competitionData[index]["status"] !== "expired") ? 
                                        (
                                            (new Date(competitionData[index]["ends_at_date"]) > new Date()) ? 
                                                "active" 
                                                : "expired"
                                        )
                                        : "expired"
                                ) 
                            : "disabled"}
                        `} 
                        onClick={() => onSelectEventElem(competitionData[index])}
                    >
                        <div className="data-event-grid__elem--date">
                            {new Date(Date.parse(competitionData[index]["starts_at_date"])).getDate()}
                        </div>

                        <div className="data-event-grid__elem--infos">
                            <div className="infos-name">
                                {"#" + competitionData[index]["id"]}
                            </div>
                            
                            <div className="infos-date-duration">
                                <span className="font-sm">S: {competitionData[index]["starts_at_date"].toString().replace("T", " ")} 📅</span>
                            </div>

                            <div className="infos-date-duration">
                                <span className="font-sm">E: {competitionData[index]["ends_at_date"].toString().replace("T", " ")} 📅</span>
                            </div>

                            <div className="infos-credits">
                                {Number(competitionData[index]["amount_credits_won"]).toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$& ').slice(0, -3)} 🟡
                            </div>
                        </div>

                        <div className="data-event-grid__elem--delete" onClick={(e)=> {e.stopPropagation(); deleteCompetition(competitionData[index]["id"], competitionData[index]["name"])}}>
                            🗑
                        </div>
                    </div>
                ))) : (
                    <p className="text-center">No competitions were found.</p>
                )}
            </div>
        </div>
    )
}

export { Competitions };